<template>
  <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      append-to-body
      title="查看图片"
      width="600px"
      top="5vh">
    <div>
      <span style="position: relative">
        <img width="300px" height="200px" :src="model.photoPath" @click.self="showBigImage($event)">
        <div style="position: absolute;bottom: 10px;left: 50%;transform: translateX(-50%);color: white">{{model.createdTime}}</div>
        <div style="position: absolute;bottom: 30px;left: 50%;transform: translateX(-50%);color: white">{{model.purchaseOrderNo}}</div>
      </span>
    </div>

    <big-img
        :visible="photoVisible"
        :url="bigImgUrl"
        :created-time="model.createdTime"
        :purchase-order-no="model.purchaseOrderNo"
        @closeClick="photoVisible = false"/>
  </el-dialog>
</template>

<script>

  import BigImg from "@/components/BigImgByIncoming";
  export default {
    name:"IncomingPictureList",
    components: {BigImg},
    data() {
      return {
        photoVisible: false,
        bigImgUrl: "",
        pcNo: "",
        dialogVisible: false,
        model:{
          photoPath:"",
          purchaseOrderNo:"",
          createdTime:"",
        },
      };
    },
    methods: {
      open(row) {
        console.log(row);
        this.dialogVisible = true;
        this.model.purchaseOrderNo = row.purchaseOrderNo;
        this.model.createdTime = row.createdTime;
        this.model.photoPath ="http://emes.stepelectric.com" + row.filePath;
      },
      showBigImage(e) {
        //点击图片函数，点击后，把photoVisible设置成true
        if (e != "") {
          this.photoVisible = true;
          this.bigImgUrl = e.currentTarget.src;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
